import { render, staticRenderFns } from "./Add_file_promotion.vue?vue&type=template&id=3be1e7fc&"
import script from "./Add_file_promotion.vue?vue&type=script&lang=js&"
export * from "./Add_file_promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports